import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchMealTypes = createAsyncThunk('mealType/fetchAll', async () => {
  const res = await axios.get('https//api.monkeybox.ai/api/mealtypes');
  return res.data;
});

export const createMealType = createAsyncThunk('mealType/create', async (formData) => {
  const res = await axios.post('https//api.monkeybox.ai/api/mealtypes', formData);
  return res.data;
});

export const updateMealType = createAsyncThunk(
  'mealType/update',
  async ({ id, formData }) => {
    const res = await axios.patch(`https//api.monkeybox.ai/api/mealtypes/${id}`, formData);
    return res.data;
  }
);

const mealTypeSlice = createSlice({
  name: 'mealType',
  initialState: {
    mealTypes: [],
    isLoading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetMealTypeState(state) {
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMealTypes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchMealTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.mealTypes = action.payload;
      })
      .addCase(fetchMealTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
      .addCase(createMealType.fulfilled, (state, action) => {
        state.isLoading = false;
        state.mealTypes.unshift(action.payload);
        state.success = true;
      })
      .addCase(updateMealType.fulfilled, (state, action) => {
        state.mealTypes = state.mealTypes.map((mt) =>
          mt.id === action.payload.id ? action.payload : mt
        );
        state.success = true;
      });
  },
});

export const { resetMealTypeState } = mealTypeSlice.actions;
export default mealTypeSlice.reducer;
